import { v5 as uuidv5 } from 'uuid';
const NAMESPACE = '00000000-0000-0000-0000-000000000000';
export const generateTraceId = (id, serviceName) => uuidv5(`${serviceName}${id}`, NAMESPACE).replace(/-/g, '');
//# sourceMappingURL=generate-trace-id.js.map